export interface Environment {
  production: boolean;
  version: string;
  dashboardUrl: string;
  firebaseConfig: FirebaseConfig;
  apiUrl: string;
  teamsDomain: string;
};

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
  region?: string;
}

export const environment: Environment = {
  production: false,
  version: '1.0.0',
  dashboardUrl: 'https://dashboard.stg.crewdle.com',
  firebaseConfig: {
    apiKey: 'AIzaSyDHDgmA574NVeMWV9SpW-q4QQMjkANuueg',
    authDomain: 'crewdle-sdk-stg.firebaseapp.com',
    projectId: 'crewdle-sdk-stg',
    storageBucket: 'crewdle-sdk-stg.firebasestorage.app',
    messagingSenderId: '519415702791',
    appId: '1:519415702791:web:5dd39042f881cfde3251a2',
    measurementId: 'G-65GE57FYE4',
    region: 'northamerica-northeast1',
  },
  apiUrl: 'https://api.stg.crewdle.ai',
  teamsDomain: 'teams.stg.crewdle.ai',
};
